var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitlecase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    fill: "currentColor",
    viewBox: "0 0 19 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.648.002a.643.643 0 0 1 .604.42l4.498 12.21a.643.643 0 1 1-1.207.446L8.277 9.642h-5.26l-1.265 3.436a.642.642 0 0 1-1.206-.445L5.045.423a.643.643 0 0 1 .603-.421Zm0 2.501L3.49 8.357h4.313L5.648 2.503ZM12.717.002a.643.643 0 0 1 .643.643v5.912c.537-.484 1.204-.771 1.928-.771 1.773 0 3.213 1.726 3.213 3.856s-1.44 3.856-3.214 3.856c-.723 0-1.39-.287-1.928-.771v.128a.643.643 0 0 1-1.285 0V.645a.643.643 0 0 1 .643-.643Zm2.57 12.21c.855 0 1.928-.921 1.928-2.57 0-1.65-1.073-2.57-1.928-2.57-.854 0-1.928.92-1.928 2.57 0 1.649 1.074 2.57 1.928 2.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitlecase);
export default __webpack_public_path__ + "static/media/titlecase.0dbd09aac1e1910d0f77238f4c82950e.svg";
export { ForwardRef as ReactComponent };